export default "__VITE_ASSET__16f6eb8f__"